"use strict";

try {
    window.$ = window.jQuery = require('jquery');
    require('jquery-typeahead');

} catch (e) {
}

import * as Util from './util.js';
import { Throttle } from './throttle';
import { Map } from './map';
import { i18n } from './i18n';
import { IconProvider } from "./iconProvider";
import { MapStyle } from "./mapStyle";
import { OSM } from './osm.js';
import { Filter } from './filter.js';
import './pullup.js';
import { restoreFilters } from './storage.js';

// const fpAptJson = 'https://cdn.foxpost.hu/foxpost_terminals_extended_v3.json';
let isEn = window.location.href.includes('/en/') || window.location.href.includes('lang=en');
let isNoMapUrl = window.location.href.includes('map=hide');
let desktopHeight = window.location.href.includes('desktop_height=');
let tabletWidth = window.location.href.includes('tablet_width=');
let tabletHeight = window.location.href.includes('tablet_height=');
let mobileWidth = window.location.href.includes('mobile_width=');
let mobileHeight = window.location.href.includes('mobile_height=');
let fpAptJson = $("[name='cdn-url']").attr("content");
const osm = new OSM(fpAptJson);
let url = window.location.href;

// standard size
let mapHeight = 450;
let aptListHeight = 450;
let mapWidth = 100;
let aptListWidth = 100;
let tabletWidthValue = 0;
let tabletHeightValue = 0;
let mobileWidthValue = 0;
let mobileHeightValue = 0;
let desktopHeightValue = 0;
let htmlHeight = 0;
let htmlWidth = 0;


window.addEventListener('load', (event) => {
    setTimeout(function () {
        isNoMap();
        // setContainerHeight();
        if((tabletWidth && tabletHeight) || (mobileWidth && mobileHeight) || (desktopHeight)){
            console.log('load belépett');
            // setContainerHeightByParams();
        }
        osm.setAptListFilter()
    }, 500);
});
window.addEventListener('resize', (event) => {
    Util.setRestrictedListHeight()
})

// window.addEventListener('resize', Throttle.throttle((event) => {
//     // setContainerHeight();
// }, 300));


const toggleBackToTop = () => {
    let $listContainer = $('.apt-list');

    $('.apt-list__back-to-top').toggleClass('hidden', $listContainer.scrollTop() < 600);
};

const setContainerHeight = () => {
    const documentHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const documentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    //let mapHeight = (documentHeight - $('.search-box').outerHeight(true) - ($('.header:visible').outerHeight(true) || 0));

    switch(true){
        case documentWidth < 992 && documentWidth > 400:
            mapHeight = 300;
            aptListHeight = 300;
            break;
        case documentWidth < 400:
            mapHeight = 200;
            aptListHeight = 231;
            break;
        default:
            mapHeight = 450;
            aptListHeight = 450;
            break;
    }
    //mapHeight = Math.ceil(mapHeight * 0.8);
    $('.map').css('height', mapHeight + 'px');
    $('.apt-list').css('height', aptListHeight + 'px');
};

const setContainerHeightByParams = () => {
    const documentHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const documentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    //let mapHeight = (documentHeight - $('.search-box').outerHeight(true) - ($('.header:visible').outerHeight(true) || 0));

    if(tabletWidth && tabletHeight){
        const tempArray = url.split("tablet_width=");
        const tempArray2 = tempArray[1].split("&tablet_height")
        tabletWidthValue = tempArray2[0];
        const tempArray3 = url.split("tablet_height=");
        const tempArray4 = tempArray3[1].split("&")
        tabletHeightValue = tempArray4[0];
    }

    if(mobileWidth && mobileHeight){
        const tempArray = url.split("mobile_width=");
        const tempArray2 = tempArray[1].split("&mobile_height")
        mobileWidthValue = tempArray2[0];
        const tempArray3 = url.split("mobile_height=");
        const tempArray4 = tempArray3[1].split("&")
        mobileHeightValue = tempArray4[0];
    }

    if(desktopHeight){
        const tempArray = url.split("desktop_height=");
        const tempArray2 = tempArray[1].split("&")
        desktopHeightValue = tempArray2[0];
    }

    switch(true){
        case documentWidth < 992 && documentWidth > 400:
            htmlHeight = tabletHeightValue;
            htmlWidth = tabletWidthValue
            //aptListHeight = tabletHeightValue;
            //aptListWidth = tabletWidthValue;
            $('html').css('height', htmlHeight + 'px');
            $('html').css('width', htmlWidth + 'px');
            $('html').css('overflow', 'hidden');
            /*
            $('.map').css('height', mapHeight + 'px');
            $('.map').css('width', mapWidth + 'px');
            $('.apt-list').css('height', aptListHeight + 'px');
            $('.apt-list').css('width', aptListWidth + 'px');
            */
            console.log('tablet: ');
            console.log(htmlHeight);
            console.log(htmlWidth);
            /*
            console.log(aptListHeight);
            console.log(aptListWidth);
            */
            break;
        case documentWidth < 400:
            htmlHeight = mobileHeightValue;
            htmlWidth = mobileWidthValue
            //aptListHeight = mobileHeightValue;
            //aptListWidth = mobileWidthValue;
            $('html').css('height', htmlHeight + 'px');
            $('html').css('width', htmlWidth + 'px');
            $('html').css('overflow', 'hidden');
            /*
            $('.map').css('height', mapHeight + 'px');
            $('.map').css('width', mapWidth + 'px');
            $('.apt-list').css('height', aptListHeight + 'px');
            $('.apt-list').css('width', aptListWidth + 'px');
            */
            console.log('mobile: ');
            console.log(htmlHeight);
            console.log(htmlWidth);
            /*
            console.log(aptListHeight);
            console.log(aptListWidth);
            */
            break;
        default:
            htmlHeight = desktopHeightValue;
            //aptListHeight = desktopHeightValue;
            $('html').css('height', htmlHeight + 'px');
            $('html').css('overflow', 'hidden');
            /*
            $('.map').css('height', mapHeight + 'px');
            $('.apt-list').css('height', aptListHeight + 'px');
            */
            console.log('desktop: ');
            console.log(htmlHeight);
            //console.log(aptListHeight);
            break;
    }
};

const isNoMap = () => {
    if(isNoMapUrl){
        $('.search-box').hide();
        $('.map').hide();
        $('.apt-list .button__jump-to').hide();
        $('.apt-list').css('max-width', '100%');
        $('.map-container').css('display', 'none');
    }
}

const getTheme = () => {
    return $('body').data('app-theme');
};
/**
 * Google Map load init
 * @deprecated
 */
document.addEventListener("DOMContentLoaded", function () {
    return;
    let mapElement = document.getElementById('map');
    const $body = $('body');
    let language = $body.data('app-lang');

    Map.loadGoogleMapsApi(language).then(function (googleMaps) {
        const iconProvider = new IconProvider(
            {
                theme: $body.data('app-theme'),
                markerIconBaseUrl: $body.data('app-base-url') + '/assets/images/'
            }
        );

        let map = Map.createMap(googleMaps, mapElement, MapStyle.getStyles(getTheme()));
        const MapManager = new mapManager({ i18n: i18n, map: map, iconProvider: iconProvider });
        MapManager.init();
    });
});



class mapManager {
    /**
     *
     * @param {Object} options
     */
    constructor(options) {
        this.map = options.map || null;
        this.iconProvider = options.iconProvider || null;
        this.i18n = options.i18n || null;
        this.isLoadIndicatorEnabled = options.isLoadIndicatorEnabled || true;
    }

    /**
     *
     * @returns {IconProvider}
     */
    getIconProvider() {
        return this.iconProvider;
    }

    /**
     *
     * @returns {i18n}
     */
    getI18n() {
        return this.i18n;
    }


    init() {
        const self = this;
        const map = this.map;

        const $body = $('body');
        /**
         * is discount enabled or not
         *
         * @type {boolean}
         */
        let discountEnabled = !!$body.data('discount');
        /**
         * store google map markers
         * @type {Array}
         */
        let markers = [];
        /**
         * reference to the currently opened info window or null
         */
        let activeInfoWindow;
        /**
         * apt data indexed by place id
         * @type {{}}
         */
        let indexedApt = {};
        /**
         * info window button style
         * @type {string}
         */
        const redButtonStyle = 'margin-top:5px;display:inline-block;background: white;border-radius: 3px;color:#B70100;border: 2px solid #B70100;padding: 5px 8px;text-decoration: none;';
        /**
         * Door opening QR code URL of edigital APT.
         * @type {string}
         */
        const edigitalDoorOpeningQrCodeUrl = 'https://foxpost.hu/uploads/documents/hu/qrkod.png';
        /**
         * Place id of edigital APT.
         * @type {number}
         */
        const edigitalPlaceId = 200526;

        /**
         *
         * @returns {string}
         */
        const getRedButtonStyle = () => {
            return redButtonStyle;
        };
        /**
         * replace vars in a template string
         *
         * @param {string} template
         * @param {Object} obj
         * @returns {*}
         */
        const replaceTemplateVars = (template, obj) => {
            Object.entries(obj).forEach(entry => {
                let key = entry[0];
                let value = entry[1];
                template = template.replace(new RegExp('{' + key + '}', 'g'), value);
            });

            return template;
        };
        /**
         * clear all animation from markers
         */
        const clearMarkerAnimation = () => {
            markers.forEach(function (marker) {
                marker.setAnimation(null);
            });
        };
        /**
         * send the selected apt data to parent window
         *
         * @param {Object} apt
         */
        const sendMessage = (apt) => {
            let aptData = JSON.stringify(apt);
            Util.postSelectedApm(apt)
        };
        /**
         * get an apt object by place id
         *
         * @param {BigInteger} placeId
         * @returns {*}
         */
        const getApt = (placeId) => {
            return indexedApt[placeId];
        };
        /**
         * whether is the given apt discounted or not
         *
         * @param {Object} apt
         * @returns {boolean}
         */
        const isAptDiscounted = (apt) => {
            return apt.sdapt === 'X';
        };
        /**
         * close active info window if opened
         */
        const closeActiveInfoWindow = () => {
            if (activeInfoWindow != null) {
                activeInfoWindow.close();
            }
        };

        const escapeRegExp = (string) => {
            string = String(string);
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        };

        const selectAptInList = (placeId) => {
            let itemsHeight = 0;
            let selected = false;
            $('.apt-list__item').removeClass('active').each(function (e, i) {
                const $this = $(this);
                if ($this.attr('id') === 'apt-list__item-' + placeId) {
                    selected = true;
                }
                if (!selected) {
                    itemsHeight += parseInt($this.css('height').replace('px', ''));
                }
            });

            const $li = $('#apt-list__item-' + placeId);
            // const index = $li.siblings(':visible').addBack().index($li);
            const scrollTop = itemsHeight + parseInt($('.checkbox__container').css('height').replace('px', ''));

            $li.addClass('active');
            $('.apt-list').animate({ scrollTop: scrollTop }, 'slow');
        };


        /**
         * queries the user location if possible
         */
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                let pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                map.setCenter(pos);
            }, function (e) {
                console && console.log && console.log(e);
            });
        }
        /**
         * set a listener to google maps on window resize
         */
        // google.maps.event.addDomListener(window, 'resize', function () {
        //     if (map && 'getCenter' in map) {
        //         google.maps.event.trigger(map, 'resize');
        //         map.setCenter(map.getCenter());
        //     }
        // });
        /**
         * get apt JSON from cdn and process it
         */
        $.getJSON(fpAptJson, function (aptData) {

            if (!Array.isArray(aptData) || aptData.length < 1) {
                self.showAlert(self.getI18n().t('We could not load locker data. Please reload the page to try again.'));
                return false;
            }

            const districtText = self.getI18n().t('district');

            aptData.forEach(function (item, index) {
                let districtValue = '';
                if (item.city === 'Budapest') {
                    const regex = /Budapest\s*([xivXIV]+)\s*,/;
                    const found = item.address.match(regex);
                    let district = found && found[1] || '';
                    if (district) {
                        districtValue = district + ' ' + districtText + ', '
                            + Util.romanToInt(district) + ' ' + districtText + ' '
                            + district + '. ' + districtText + ', '
                            + Util.romanToInt(district) + '. ' + districtText;
                    }
                }
                aptData[index]['district'] = districtValue;
            });

            let aptDataArray = $.makeArray(aptData);
            aptDataArray.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });

            let $listContainer = $('.apt-list');
            let listItems = '';

            $('.apt-count').html(aptDataArray.length);
            $.typeahead({
                minLength: 2,
                accent: true,
                // correlativeTemplate:true,
                maxItem: 100,
                input: '.js-typeahead-apt',
                order: "asc",
                emptyTemplate: self.getI18n().t('no result, for {{query}}', {'query': '{query}'}),
                templateValue: "{{name}}, {{address}}",
                template: '<span>' +
                    '{{name}}, {{address}}' +
                    '</span><br><small>{{findme}}</small>',
                source: {
                    display: ["name", "address", "street", "findme", 'district'],
                    data: aptData
                },
                callback: {
                    onClickAfter: function (node, a, item, event) {

                        event.preventDefault();
                        clearMarkerAnimation();
                        map.setCenter({ lat: item.geolat, lng: item.geolng });
                        markers[item.place_id].setAnimation(google.maps.Animation.BOUNCE);
                        selectAptInList(item.place_id);
                    }
                }
            });
            let index = 0;
            let hasDiscountedApt = false;
            aptDataArray.forEach(function (apt) {
                ++index;
                const placeId = apt.place_id;
                indexedApt[placeId] = apt;
                let latLng = new google.maps.LatLng(apt.geolat, apt.geolng);
                const markerIcon = {
                    url: self.getIconProvider().getAptMarkerIcon(apt),
                    scaledSize: new google.maps.Size(60, 60), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    anchor: new google.maps.Point(0, 0) // anchor
                };
                let marker = new google.maps.Marker({
                    position: latLng,
                    map: map,
                    icon: markerIcon,
                    title: apt.name
                });
                let qrCodeImg = '';
                let qrCodeImgDetail = '';
                if (placeId === edigitalPlaceId) {
                    qrCodeImg = '<div><div class="apt-qr-title">' + self.getI18n().t('Door opening QR code') + ':</div></div><img alt="Qr" class="apt-qr-img apt-qr-img--edigital" src="' + edigitalDoorOpeningQrCodeUrl + '"></div>';
                    qrCodeImgDetail = '<span><span class="apt-qr-title">' + self.getI18n().t('Door opening QR code') + ':</span></span><img alt="Qr" class="apt-qr-img apt-qr-img--edigital" src="' + edigitalDoorOpeningQrCodeUrl + '"></div>';
                }

                const isDiscounted = isAptDiscounted(apt);

                if (isDiscounted) {
                    hasDiscountedApt = true;
                }

                let infoWindowContent =
                    '<div style="margin-bottom: 5px;"><a class="btn btn-red button__select-apt" href="#" style="{redButtonStyle}" data-place-id="' + placeId + '">' + self.getI18n().t('Select') + '</a></div>'
                    + '<div><b>{aptName}</b>, {address}</div>{qrCodeImg}<div>{findMe}</div>{opening}{loadTitle}';

                let opening = '';

                let listItemTemplate = '<li id="apt-list__item-{placeId}" class="apt-list__item{isDiscounted}">'
                    + '<span class="apt-list__item-header">'
                    + '<span class="apt-list__item-header-row">'
                    + '<span class="apt-list__item-name">{loadIcon}{aptName}</span>'
                    + (discountEnabled ? '<span title="{discountedPriceText}" class="apt-list__item-discount">{discountedPriceText}</span>' : '')
                    + '</span>'// end of row 1
                    + '<span class="apt-list__item-header-row">'
                    + '<span class="apt-list__item-city">{group}</span>'
                    + '<a href="#" class="apt-list__item-collapse js-collapse" data-collapse-target="#apt-list__item-hidden-{placeId}">{detailsText}</a>'
                    + '</span>'// end of row 2
                    + '<span class="apt-list__item-address">{address}</span>'
                    + '</span>'// end of header
                    + '<span class="d-none apt-list__item--hidden" id="apt-list__item-hidden-{placeId}">{qrCodeImgDetail}<span class="apt-list__item-find-me">{findMe}</span>'
                    + '<span class="apt-list__item-opening">{opening}</span></span>'
                    + '<span class="apt-list__item-buttons"><a class="btn btn-red button__select-apt" href="#" data-place-id="{placeId}">{selectText}</a>'
                    + '<a class="btn btn-red button__jump-to" href="#" data-place-id="{placeId}">{showOnMapText}</a>'
                    + '</span></li>';

                if (apt.open.hetfo !== undefined) {
                    opening =
                        '<table class="opening__table"><tr><td>' + self.getI18n().t('Monday') + '</td><td>' + $.trim(apt.open.hetfo) + '</td></tr>'
                        + '<tr><td>' + self.getI18n().t('Thuesday') + '</td><td>' + $.trim(apt.open.kedd) + '</td></tr>'
                        + '<tr><td>' + self.getI18n().t('Wednesday') + '</td><td>' + $.trim(apt.open.szerda) + '</td></tr>'
                        + '<tr><td>' + self.getI18n().t('Thursday') + '</td><td>' + $.trim(apt.open.csutortok) + '</td></tr>'
                        + '<tr><td>' + self.getI18n().t('Friday') + '</td><td>' + $.trim(apt.open.pentek) + '</td></tr>'
                        + '<tr><td>' + self.getI18n().t('Saturday') + '</td><td>' + $.trim(apt.open.szombat) + '</td></tr>'
                        + '<tr><td>' + self.getI18n().t('Sunday') + '</td><td>' + $.trim(apt.open.vasarnap) + '</td></tr>'
                        + '</table>';
                    opening = self.getI18n().t('Opening') + ': ' + opening;
                }
                let loadTitle = '';
                let loadIcon = '';
                if (self.isLoadIndicatorEnabled) {
                    loadTitle = self.getLoadTitle(apt);
                    loadIcon = $('<img/>', {
                        'data-placement': 'top',
                        'data-toggle': 'popover',
                        'data-container': 'body',
                        'data-trigger': 'focus',
                        'tabindex': index + 50,
                        'alt': loadTitle,
                        'title': loadTitle,
                        'data-content': loadTitle,
                        'class': 'apt-list__item-load-indicator',
                        src: self.getIconProvider().getAptListLoadIcon(apt)
                    }).wrap('<p/>').parent().html();
                }
                const obj = {
                    loadIcon: loadIcon,
                    loadTitle: loadTitle,
                    qrCodeImgDetail: qrCodeImgDetail,
                    qrCodeImg: qrCodeImg,
                    aptName: apt.name,
                    address: apt.address,
                    group: apt.group,
                    findMe: apt.findme,
                    opening: opening,
                    redButtonStyle: getRedButtonStyle(),
                    placeId: placeId,
                    detailsText: self.getI18n().t('Details'),
                    showOnMapText: self.getI18n().t('Show on map'),
                    discountedPriceText: self.getI18n().t('Discounted price'),
                    selectText: self.getI18n().t('Select'),
                    isDiscounted: isDiscounted ? ' apt-list__item--discounted' : ''
                };

                infoWindowContent = replaceTemplateVars(infoWindowContent, obj);

                listItems += replaceTemplateVars(listItemTemplate, obj);
                let infoWindow = new google.maps.InfoWindow({
                    content: infoWindowContent,
                    maxWidth: 400
                });
                marker.addListener('click', function () {
                    selectAptInList(placeId);

                    closeActiveInfoWindow();
                    infoWindow.open(map, marker);
                    activeInfoWindow = infoWindow;
                });

                markers[placeId] = marker;
            });

            $listContainer.append(replaceTemplateVars('<ul class="apt-list__list">{li}<li class="apt-list__back-to-top hidden">'
                + '<a href="#apt-list__header" title="' + self.getI18n().t('Jump to top') + '" class="apt-list__back-to-top-link"></a></li></ul>', { li: listItems }));

            if (!hasDiscountedApt) {
                $('.checkbox__container').hide();
            }

            $listContainer.on('scroll', Throttle.throttle((event) => {
                toggleBackToTop();
            }, 300));

            const $listItems = $('.apt-list__item');

            // $('#apt-list-filter').keyup(function () {
            //     const isChecked = $('#only-discounted-apt-cb').prop('checked');
            //     const keyWord = $.trim($('#apt-list-filter').val());
            //     const re = new RegExp(escapeRegExp(keyWord), 'i');
            //     $listItems.show().filter(function () {
            //         //filter for only discounted apts
            //         if (isChecked) {
            //             return !re.test($(this).text()) || !$(this).hasClass('apt-list__item--discounted');
            //         }
            //         // filter for all apts
            //         return !re.test($(this).text());
            //     }).hide();
            // });

            $('.js-collapse').click(function (e) {
                e.preventDefault();
                const $this = $(this);
                $this.toggleClass('collapsed');
                $($this.data('collapse-target')).toggleClass('collapsed');
                $this.data('collapse-target');
            });

            $('.content').on('click', '.button__select-apt', function (e) {
                e.preventDefault();
                let placeId = $(this).data('place-id');
                if (placeId && typeof markers[placeId] !== undefined) {
                    sendMessage(getApt(placeId));
                }
            });

            $('#only-discounted-apt-cb').change(function () {
                const isChecked = $(this).prop('checked');
                const keyWord = $.trim($('#apt-list-filter').val());
                const re = new RegExp(escapeRegExp(keyWord), 'i');

                $listItems.show().filter(function () {
                    //filter for only discounted apts
                    if (isChecked) {
                        if ('' !== keyWord) {
                            // filter for keyword as well
                            return !re.test($(this).text()) || !$(this).hasClass('apt-list__item--discounted');
                        } else {
                            return !$(this).hasClass('apt-list__item--discounted');
                        }
                    } else {
                        // filter for all apts
                        return !re.test($(this).text());
                    }
                }).hide();

                markers.forEach(function (marker, placeId) {
                    if (isChecked) {
                        closeActiveInfoWindow();
                        if (!isAptDiscounted(indexedApt[placeId])) {
                            marker.setVisible(false);
                        }
                    } else {
                        marker.setVisible(true);
                    }
                })
            });

            

        }).fail(function (e) {
            alert(self.getI18n().t('Unable to load APT list, please try again later'));
            if (e.statusText) {
                console.log(e.statusText, e.status);
            }
        });
    }

    /**
     *
     * @param {Object} apt
     */
    getLoadTitle(apt) {
        const load = apt.load || '';
        if ('overloaded' === load) {
            // return this.getI18n().t('The locker is moderately saturated, in case of parcel delivery there may be no free slot, the delivery delay is expected on average 1 day.');
            return this.getI18n().t('The locker is very saturated, there may be no free compartment when sending parcels, delivery is expected to be 2-3 days late.');
        }
        if ('medium loaded' === load) {
            return this.getI18n().t('The locker is moderately saturated, in case of parcel delivery there may be no free slot, the delivery delay is expected on average 1 day.');
        }
        return this.getI18n().t('The locker is not saturated, parcel delivery is uninterrupted, there is no delivery delay.');
    }

    /**
     *
     * @param {string} text
     */
    showAlert(text) {
        alert(text);
    }
}

/* zoom with ctrl only */
document.querySelector('canvas.mapboxgl-canvas').addEventListener('wheel', (ev) => {
	if (ev.ctrlKey) return
	ev.stopImmediatePropagation()
})


document.getElementById("viewToggle").addEventListener("click", Util.handleListView);
document.addEventListener('DOMContentLoaded', Util.handleListView)
document.addEventListener('DOMContentLoaded', ()=>{
    Util.setMapContainerHeight()
    $("#searchClearButton, #searchClearButtonPaperBox").on("click", (e)=>{
        $('#apt-list-filter, #apt-list-filter-paper-box').val("")
        osm.keyword = ""
        osm.handleSearchButtons()
        osm.removeAnimatedMarker()
        osm.loadData()
    })
    $("#aptSearchButton, #searchButtonPaperBox").on("click", (e)=>{
        e.preventDefault();
        osm.searchApms(true)
    })
    $("#searchClearButton, #searchClearButtonPaperBox").hide()
})
document.addEventListener("DOMContentLoaded", ()=>{
    let filterBtn = $(".filterToggleButton");
    filterBtn.on('click', (e) => {
        let optionsDiv = $(".filter-options");
        let listItemsDiv =  $(".list-items");
        filterBtn.toggleClass('active')
        filterBtn.hasClass("active") ? optionsDiv.show() : optionsDiv.hide()
        filterBtn.hasClass("active") ? listItemsDiv.hide() : listItemsDiv.show()
    })
    
})

document.addEventListener("DOMContentLoaded", () => {
    let cardHeaders = document.querySelectorAll(".card-header");

    cardHeaders.forEach(cardHeader => {
        cardHeader.addEventListener("click", () => {
            let body = cardHeader.nextElementSibling;

            if (body.style.display === "block") {
                body.style.display = "none";
                cardHeader.classList.add("collapsed");
            } else {
                body.style.display = "block";
                cardHeader.classList.remove("collapsed");
            }
        });
    });
});
document.addEventListener("DOMContentLoaded", () => Util.setTextBoxes());
document.addEventListener("DOMContentLoaded", () => osm.handleFilters());
document.addEventListener("DOMContentLoaded", () => osm.setSearchClearButtonEvent());
document.addEventListener("DOMContentLoaded", () => restoreFilters());
document.addEventListener("DOMContentLoaded", () => {
    $('.apt-list').on('scroll', (e) => {
        osm.toggleBackToTop();
        var elem = $(e.currentTarget);
        let elScrollHeight= Math.floor(elem[0].scrollHeight - elem.scrollTop())
        let elOuterHeight = elem.outerHeight()
        if (elScrollHeight == elOuterHeight || (elScrollHeight - elOuterHeight) == 1) {
            osm.addChunkToList()
        }
    });
});
document.addEventListener("DOMContentLoaded", () => {
    $("#apt-list-filter-paper-box").on('click', () => {
        $("#filterPanel").height('100vh');
    });
});